import React, { useState, useEffect } from "react";
import "./index.scss";
import { Modal, Icon, Toast } from "antd-mobile";
import { createNonceStr, md5, getLocationSearch } from "@/utils/utils";
import Header from "@/components/header";
import request from "@/utils/request";

import qs from "qs";

const Income = (props) => {
  let { history, location } = props;

  let token = getLocationSearch().token;
  let orderId = getLocationSearch().orderId;
  console.log(token, "gvc");

  const handleGoProve = () => {
    history.push(`/gvc/prove`);
  };

  const [state, setState] = useState({});
  const [visible, setVisble] = useState(false);

  const initRequest = async () => {
    let appKey = "app_h5";
    let secret = "11dc72cf-88b0-46cd-91d7-b1a77fd69ee1";
    let timestamp = new Date().getTime();
    let random = createNonceStr();
    let tempStr = `appKey${appKey}secret${secret}timestamp${timestamp}random${random}token${token}`;
    let sign = md5(tempStr, 32).toString(16).toLocaleUpperCase();
    Toast.loading("loading...", 0, () => {}, true);
    const res = await request.get(
      `/api/bill/queryIncomeDetail/${orderId}`,
      { token },
      {
        appKey: appKey,
        timestamp: timestamp,
        random: random,
        token: token,
        sign: sign,
      }
    );
    Toast.hide();
    if (res.data.data) {
      console.log(res.data.data, "res.data.data");
      setState(res.data.data);
    } else if (res.data.errorMsg) {
      Toast.offline(res.data.errorMsg);
    }
  };
  const showDialog = (e) => {
    e?.preventDefault();
    setVisble(true);
  };
  const onClose = (e) => {
    e?.preventDefault();
    setVisble(false);
  };

  useEffect(() => {
    document.title = "收入明细";
    initRequest();
  }, []);

  return (
    <div className="page_box">
      <Modal
        className="big_model"
        visible={visible}
        transparent
        maskClosable={false}
        onClose={onClose}
        title="抽佣说明"
        footer={[
          {
            text: "已知晓",
            onPress: () => {
              onClose();
            },
          },
        ]}
      >
        <div style={{ height: 100, overflow: "scroll" }}>
          司机车费收入：包含起步价、里程费、时长费、远途费、预约单取消费、基础费补足，不包含附加费、春节服务费。
          <br />
          乘客车费金额：包含起步价、里程费、时长费、远途费、预约单取消费、基础费补足，不包含附加费、春节服务费。
          <br />
          抽佣比例=（乘客车费金额-司机车费收入）/乘客车费金 额*100%
          <br />
          *附加费、春节服务费平台不抽佣，全额结算给到司机
        </div>
      </Modal>
      <div className="card">
        {state.fare ? (
          <div className="item">
            <div className="label">车费</div>
            <div className="value">{state.fare}元</div>
          </div>
        ) : null}
        {state.highwayFee ? (
          <div className="item">
            <div className="label">高速费</div>
            <div className="value">{state.highwayFee}元</div>
          </div>
        ) : null}
        {state.bridgeFee ? (
          <div className="item">
            <div className="label">过路费</div>
            <div className="value">{state.bridgeFee}元</div>
          </div>
        ) : null}
        {state.parkFee ? (
          <div className="item">
            <div className="label">停车费</div>
            <div className="value">{state.parkFee}元</div>
          </div>
        ) : null}
        {state.redPacket ? (
          <div className="item">
            <div className="label">春节服务费</div>
            <div className="value">{state.redPacket}元</div>
          </div>
        ) : null}
        {state.infoServiceFee ? (
          <div className="item">
            <div className="label">信息服务费</div>
            <div className="value">{state.infoServiceFee}元</div>
          </div>
        ) : null}
      </div>
      {state.isExhibition === 0 ? (
        <div className="card">
          <div className="title">
            <div className="left">收入分析</div>
            <div className="right" onClick={showDialog}>
              抽佣说明
              <Icon type="right" className="icon" />
            </div>
          </div>
          <div className="item">
            <div className="label">司机车费收入</div>
            <div className="value">{state.driverTotalFee}元</div>
          </div>
          {/* <div className="item">
            <div className="label">乘客车费金额</div>
            <div className="value">{state.passengerTotalFee}元</div>
          </div> */}
          <div className="item">
            <div className="label">抽佣比例</div>
            <div className="value">{state.commissionProportion}%</div>
          </div>
        </div>
      ) : null}
    </div>
  );
};
export default Income;
